import { render, staticRenderFns } from "./ExModalHeader.vue?vue&type=template&id=7ca4d2bc"
import script from "./ExModalHeader.vue?vue&type=script&lang=js"
export * from "./ExModalHeader.vue?vue&type=script&lang=js"
import style0 from "./ExModalHeader.vue?vue&type=style&index=0&id=7ca4d2bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports